<template>
    <input class="prospectus-date-picker form-control" :placeholder="placeholder" :id="id"/>
</template>
<script>
export default {
    props: {
        placeholder: "",
        id: ""
    },
    mounted: function() {
      var self = this;
      $(this.$el).datepicker({
        onSelect: function(date) {
          self.$emit('update-date', date);
        }
      });

      $(this.$el).change(function(){
        self.$emit('update-date', $(this).val());
      })
    },
    beforeDestroy: function() {
        $(this.$el).datepicker('hide').datepicker('destroy');
    }
}
</script>


// WEBPACK FOOTER //
// source/js/Prospectus3Page/src/DatePicker.vue